import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import * as XLSX from "xlsx";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";

import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin, { Draggable } from "@fullcalendar/interaction";
import BootstrapTheme from "@fullcalendar/bootstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import {
  addNewEvent as onAddNewEvent,
  deleteEvent as onDeleteEvent,
  getCategories as onGetCategories,
  getEvents as onGetEvents,
  updateEvent as onUpdateEvent,
  resetCalendar,
} from "../../store/actions";
//css
// import "@fullcalendar/bootstrap/main.css";

//redux
import { useSelector, useDispatch } from "react-redux";

import { createSelector } from "reselect";
import { toast } from "react-toastify";

const ProductionPlanning = (props) => {
  document.title = "Production Planning | OptiMize";
  const [ppData, setPPData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedMachine, setSelectedMachine] = useState("");
  const [events, setEvents] = useState([]);
const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();

  const calendarpage = createSelector(
    (state) => state.calendar,
    (state) => ({
      events: state.events,
      categories: state.categories,
      isEventUpdated: state.isEventUpdated,
    })
  );

 // const { events, categories, isEventUpdated } = useSelector(calendarpage);
  const authToken = localStorage.getItem("access");
  //const authToken = JSON.parse(localStorage.getItem("authUser")).token;
  const [machine, setMachine] = useState();
  const [machines, setMachines] = useState([]);
  const [machineData, setMachineData] = useState();
  const [childPart, setChildPart] = useState();
  const fetchMachine = async () => {
    try {
      const response = await fetch("https://api.hanoch.in/api/machines", {
        // headers: {
        //   "Content-Type": "application/json",
        //   Authorization: `Bearer ${authToken}`, // Replace with your actual token
        // },
      });

      if (response.ok) {
        const machines = await response.json();
        // console.log(data);
        setMachines(machines.data);
        setSelectedMachine(machines.data[0].id)
      } else if (response.status === 401) {
        // Unauthorized: Log out the user
        localStorage.removeItem("access");
        localStorage.removeItem("role");
      } else {
        console.error("Error fetching data:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleExcelUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formDataExcel = new FormData();
    formDataExcel.append("file", file);

    try {
      setIsLoading(true);
      const response = await fetch("https://api.hanoch.in/production_planning/upload-material-plan/", {
        method: "POST",
        body: formDataExcel,
      });

      if (response.ok) {
        const result = await response.json();
        console.log("result", result);
        toast.success("Excel uploaded successfully.");

        const plan = result?.data?.[0];
        const partNumber = result.parts?.[0]?.part_number;
        const partId = result.parts?.[0]?.parent;
        fetchproductionPlanning(partId);
        if (plan && partNumber) {
          setFormData((prev) => ({
            ...prev,
            part: partNumber,
            backlog: plan.backlog_qty || "",
            date:plan.date,
            month_qty:plan.month_qty || "",
            total_parts_required: plan.month_qty || "",
            month: `${plan.year}-${String(plan.month).padStart(2, "0")}`, // format YYYY-MM
          }));
        }
      } else {
        const errorText = await response.text();
        toast.error(`Upload failed: ${response.status} - ${errorText}`);
      }
    } catch (error) {
      toast.error("Error uploading Excel file.");
      console.error("Upload error:", error);
    }
    finally{
      setIsLoading(false)
    }
  };
  useEffect(() => {
    if (ppData && ppData.machine_id) {
      setFormData((prev) => ({
        ...prev,
        machine: ppData.machine_name,
        cycleTime: ppData.ideal_cycle_time || "",
        max_parts_per_shift: ppData.max_parts_per_shift || "",
      }));
    }
  }, [ppData]);

  const fetchproductionPlanning = async (partId) => {
    try {

      const response = await fetch(
        `https://api.hanoch.in/production_planning/upload-material-plan/?part_id=${partId}`,
        {
          method: "GET",

        }
      );

      if (response.ok) {
        const data = await response.json();
        // console.log("this is pp data", data);
        setPPData(data);
      } else if (response.status === 401) {
        // Unauthorized: Log out the user
        localStorage.removeItem("access");
        localStorage.removeItem("role");
      } else {
        console.error("error fetching child data:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching child data:", error);
    }
  };

  const fetchChildParts = async (e) => {
    try {
      // Fetch data from your API
      const response = await fetch(
        "https://api.hanoch.in/api/parts",
        {
          method: "GET",
          // headers: {
          //   //   "Content-Type": "application/json",
          //   Authorization: `Bearer ${authToken}`, // Replace with your actual token
          // },
        }
      );

      if (response.ok) {
        const data = await response.json();
        // console.log("this is child part data", data);
        setChildPart(data);
      } else if (response.status === 401) {
        // Unauthorized: Log out the user
        localStorage.removeItem("access");
        localStorage.removeItem("role");
      } else {
        console.error("error fetching child data:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching child data:", error);
    }
  };

  useEffect(() => {
    fetchMachine();
    fetchChildParts();
  }, []);

  const [formData, setFormData] = useState({
  machine:"",
  date:"",
  program: "",
  month_qty: "",
  total_qty: "",
  backlog: "",
  total_parts_required:"",
  cycleTime: "",
  max_parts_per_shift: "",
  shiftsPlanned: {
    first: false,
    second: false,
    third: false,
  },
  include_sunday: false,
  part:"",
 
});
const handleChange = (e) => {
  const { name, value, type, checked } = e.target;

  if (["first", "second", "third"].includes(name)) {
    setFormData((prevData) => ({
      ...prevData,
      shiftsPlanned: {
        ...prevData.shiftsPlanned,
        [name]: checked,
      },
    }));
  } else if (name === "include_sunday") {
    setFormData((prevData) => ({
      ...prevData,
      include_sunday: value === "yes",
    }));
  } else {
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  }
};

 

 
  // useEffect(() => {
  //   fetchEvents();
  // }, []);

  const fetchEvents = async () => {
    try {
      const response = await fetch("https://api.hanoch.in/production_planning/latest_material_plans/", {
        headers: {
          "Content-Type": "application/json",
         // Authorization: `Bearer ${authToken}`, // Replace with your actual token
        },
      });

      if (response.ok) {
      
        const data = await response.json();
          console.log("calender",data)
          const calendarEvents = data.flatMap((plan) => generateCalendarFromDB(plan));
setEvents(calendarEvents);
      //    const formattedEvents = data.map((event) => ({
      //   id: event.id || event._id,
      //   title: event.title,
      //   start: event.start,
      //   className: event.className || "bg-primary text-white"
      // }));
     // setEvents(formattedEvents);
    } else {
      console.error("Error loading events:", response.statusText);
    }
  } catch (error) {
    console.error("Error fetching events:", error);
  }
};

const generateCalendarFromDB = (plan) => {
  const {
    date,
    total_qty,
    max_parts_per_shift,
    shifts_planned,
    include_sunday,
    machine_name,
    program,
  } = plan;

  const total_shifts = Math.ceil(total_qty / max_parts_per_shift);
  const shiftList = shifts_planned.split(","); // ["1", "2"]
  const startDate = new Date(date);
  const events = [];

  let i = 0;
  let shiftsAdded = 0;

  while (shiftsAdded < total_shifts) {
    const currentDate = new Date(startDate);
    currentDate.setDate(startDate.getDate() + i);

    // Skip Sunday if include_sunday is false
    if (!include_sunday && currentDate.getDay() === 0) {
      i++;
      continue;
    }

    for (const shift of shiftList) {
      if (shiftsAdded >= total_shifts) break;

      events.push({
        id: `${currentDate.toISOString()}-${shift}`,
        title: `Shift ${shift} - ${machine_name || program}`,
        start: currentDate.toISOString().split("T")[0], // "YYYY-MM-DD"
        className: "bg-primary text-white",
      });

      shiftsAdded++;
    }

    i++;
  }

  return events;
};

useEffect(() => {
  fetchEvents(); // call once on component mount
}, []);
  

  const addNewEvent = (
    total_shifts,
    startDate,
    plannedShifts,
    existingEvents
  ) => {
    let eventsAdded = 0;
    let i = 0;
    const newEvents = [...existingEvents]; // Start with the existing events

    while (eventsAdded < total_shifts) {
      const eventDate = new Date(startDate.getTime() + i * 24 * 60 * 60 * 1000);

      // Skip Sundays if includeSunday is "no"
      if (formData.include_sunday === "no" && eventDate.getDay() === 0) {
        i++;
        continue;
      }

      // Add events for each planned shift
      for (const shift of plannedShifts) {
        // Check if we have already added the required number of events
        if (eventsAdded >= total_shifts) {
          break;
        }

        const newEvent = {
          id: newEvents.length + eventsAdded, // Ensure unique ID
          title: `${shift}${" "}${formData?.machine}`,
          start: eventDate,
          className: "bg-primary text-white",
        };

        newEvents.push(newEvent); // Add to new events array
        eventsAdded++;
      }

      i++;
    }

    setEvents(newEvents);
 
  };

  // const addNewEvent = (total_shifts, startDate, plannedShifts) => {
  //   let eventsAdded = 0;
  //   let i = 0;
  //   const eventsToAdd = [];

  //   while (eventsAdded < total_shifts) {
  //     const eventDate = new Date(startDate.getTime() + i * 24 * 60 * 60 * 1000);

  //     if (formData.includeSunday === "no" && eventDate.getDay() === 0) {
  //       i++;
  //       continue;
  //     }

  //     for (const shift of plannedShifts) {
  //       if (eventsAdded >= total_shifts) {
  //         break;
  //       }

  //       const newEvent = {
  //         title: `${shift} ${machine.machine_name}`,
  //         start: eventDate,
  //         className: "bg-primary text-white",
  //       };

  //       eventsToAdd.push(newEvent);
  //       eventsAdded++;
  //     }

  //     i++;
  //   }

  //   return eventsToAdd;
  // };

  //handle the submit logic here

 const handleSubmit = async (e) => {
  e.preventDefault();

  if (formData.machine === "" || formData.part === "") {
    toast.error("Machine and part must be selected.");
    return;
  }

  const shiftsPlanned = formData.shiftsPlanned;
  const shiftMap = {
    first: "1",
    second: "2",
    third: "3",
  };

  const plannedShifts = Object.keys(shiftsPlanned)
    .filter((key) => shiftsPlanned[key])
    .map((key) => shiftMap[key]);

  if (plannedShifts.length === 0) {
    toast.error("Select at least one shift.");
    return;
  }

  const total_parts =
    parseInt(formData.total_parts_required || 0) + parseInt(formData.backlog || 0);
  const total_shifts = Math.ceil(total_parts / parseInt(formData.max_parts_per_shift || 1));
  const startDate = new Date();
  const eventsToAdd = addNewEvent(total_shifts, startDate, plannedShifts, events);

  // Prepare the final payload
 
  const [year, month] = formData.month.split("-");
 const payload = {
  machine_name:formData?.machine,
    program:ppData?.part_name,
    date:formData?.date,
    month_qty: Number(formData.month_qty),
    total_qty: Number(formData.total_parts_required),
    backlog_qty: Number(formData.backlog),
    cycle_time: Number(formData.cycleTime),
    max_parts_per_shift: Number(formData.max_parts_per_shift),
    shifts_planned: plannedShifts.join(","), // => "1,2"
    include_sunday: formData.include_sunday,
     material_number:formData.part,
     year:year,
     month:month,
  };

  try {
    const url = "https://api.hanoch.in/production_planning/save_material_plan/";

    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        // Authorization: `Bearer ${authToken}`, // Uncomment if needed
      },
      body: JSON.stringify(payload),
    });

    if (response.ok) {
      toast.success("Material plan and events submitted successfully.");
      fetchEvents();
      handleReset();
    } else {
      const error = await response.text();
      toast.error(`Submission failed: ${error}`);
    }
  } catch (error) {
    console.error("Submit error:", error);
    toast.error("Failed to submit material plan.");
  }
};

  const handleReset = () => {
    setFormData({
      machine: "",
      part: "",
      month: "",
      total_parts_required: "",
      backlog: "",
      cycleTime: "",
      max_parts_per_shift: "",
      shifts_needed: "",
      shiftsPlanned: {
        first: false,
        second: false,
        third: false,
      },
      includeSunday: "no",
    });
  };

  const deleteAllEvents = async () => {
    setLoading(true);
    try {
      const response = await fetch("http://ec2-35-154-129-107.ap-south-1.compute.amazonaws.com:3003/api/events", {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      if (response.ok) {
        setLoading(false);
        dispatch(onAddNewEvent([])); // Clear the events in the Redux store
        toast.success("All events deleted successfully.");
      } else {
        console.error("Error deleting events:", response.statusText);
      }
    } catch (error) {
      console.error("Error deleting events:", error);
    }
  };




  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="OptiMize" breadcrumbItem="Production Planning" />
          <Row className="mb-4">
            <Col xl={3} className="mt-3">
              <Card className="h-100">
                <CardBody>

                  <form onSubmit={handleSubmit}>

                    <div className="mb-3">
                      <label htmlFor="excelUpload" className="form-label">
                        Upload Excel
                      </label>

                      <input
                        type="file"
                        accept=".xlsx, .xls"
                        className="form-control"
                        id="excelUpload"
                        onChange={handleExcelUpload}
                      />
                       {isLoading ? (
            <div className="text-center justify-content-center align-items-center mt-1">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (<></>)}
                    </div>

                    <div className="mb-3">
                      <label className="col-form-label" htmlFor="machine">
                        Select Machine
                      </label>
                      <div className="col-md-10">

                        <input
                          className="form-control"
                          id="machine"
                          name="machine"
                          value={formData.machine}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="mb-3">
                      <label className="col-form-label" htmlFor="childPart">
                        Select Parts
                      </label>
                      <div className="col-md-10">
                        <input
                          className="form-control"
                          id="part"
                          type="text"
                          name="parts"
                          placeholder="part"
                          value={formData.part}
                          onChange={handleChange}
                        />

                      </div>
                    </div>

                    <div className="mb-3">
                      <label
                        htmlFor="totalPartsRequired"
                        className="col-form-label"
                      >
                        Total Parts Required In This Month
                      </label>
                      <div className="col-md-10">
                        <input
                          className="form-control"
                          id="totalPartsRequired"
                          type="number"
                          name="total_parts_required"
                          placeholder="Total parts required"
                          value={formData.total_parts_required}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    <div className="mb-3">
                      <label htmlFor="backlog" className="col-form-label">
                        Backlog
                      </label>
                      <div className="col-md-10">
                        <input
                          className="form-control"
                          id="backlog"
                          type="number"
                          name="backlog"
                          placeholder="Backlog"
                          value={formData.backlog}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    <div className="mb-3">
                      <label htmlFor="cycleTime" className="col-form-label">
                        Cycle time of the Machine
                      </label>
                      <div className="col-md-10">
                        <input
                          className="form-control"
                          id="cycleTime"
                          type="number"
                          name="cycleTime"
                          placeholder="Cyle time"
                          value={formData.cycleTime}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    <div className="mb-3">
                      <label
                        htmlFor="maxPartsPerShift"
                        className="col-form-label"
                      >
                        Max Parts Per Shift
                      </label>
                      <div className="col-md-10">
                        <input
                          className="form-control"
                          id="maxPartsPerShift"
                          type="number"
                          name="max_parts_per_shift"
                          placeholder="Max Parts/shift"
                          value={formData.max_parts_per_shift}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    <div className="mb-3">
                      <label className="col-form-label">
                        Shifts need to be Planned
                      </label>
                      {/* <div className="col-md-10">
                        <input
                          className="form-control"
                          id="cycleTime"
                          type="number"
                          name="shifts_needed"
                          placeholder="Cyle time"
                          value={formData.shifts_needed}
                          onChange={handleChange}
                        />
                      </div> */}
                      <div>
                        {["first", "second", "third"].map((shift) => (
                          <div
                            className="form-check form-check-inline"
                            key={shift}
                          >
                            <input
                              id={`inlineCheck${shift}`}
                              className="form-check-input"
                              type="checkbox"
                              name={shift}
                              checked={formData.shiftsPlanned[shift]}
                              onChange={handleChange}
                            />
                            <label
                              className="form-check-label"
                              htmlFor={`inlineCheck${shift}`}
                            >
                              {shift.charAt(0).toUpperCase() + shift.slice(1)}{" "}
                              Shift
                            </label>
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="mb-3">
                      <label className="col-form-label">Include Sunday</label>
                      <div>
                        <div className="form-check form-check-inline">
                          <input
                            id="inlineCheckYes"
                            className="form-check-input"
                            type="radio"
                            name="includeSunday"
                            value="yes"
                            checked={formData.includeSunday === "yes"}
                            onChange={handleChange}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="inlineCheckYes"
                          >
                            Yes
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            id="inlineCheckNo"
                            className="form-check-input"
                            type="radio"
                            name="includeSunday"
                            value="no"
                            checked={formData.includeSunday === "no"}
                            onChange={handleChange}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="inlineCheckNo"
                          >
                            No
                          </label>
                        </div>
                      </div>
                    </div>

                    <div className="d-flex gap-2 mt-3">
                      <Button color="primary" className="add-btn" type="submit">
                        Submit
                      </Button>
                      {/* <Button
                        color="danger"
                        className="add-btn"
                        type="button"
                        onClick={handleReset}
                      >
                        Reset
                      </Button> */}
                    </div>
                  </form>
                </CardBody>
              </Card>
            </Col>

            <Col xl={9} className="mt-3">
              <Card className="mb-0 d-flex h-100">
                <CardBody>
                  {/* fullcalendar control */}
                  <FullCalendar
                    plugins={[BootstrapTheme, dayGridPlugin, interactionPlugin]}
                    handleWindowResize={true}
                    themeSystem="bootstrap"
                    headerToolbar={{
                      left: "title",
                      center: "",
                      right: "prev,next",
                    }}
                    events={events}
                    displayEventTime={false}
                    eventDisplay="list-item:none"
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

ProductionPlanning.propTypes = {
  events: PropTypes.array,
  categories: PropTypes.array,
  className: PropTypes.string,
  onGetEvents: PropTypes.func,
  onAddNewEvent: PropTypes.func,
  onUpdateEvent: PropTypes.func,
  onDeleteEvent: PropTypes.func,
  onGetCategories: PropTypes.func,
};

export default ProductionPlanning;
